import Joyride, { type CallBackProps } from "react-joyride";
import type { Step } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";

type HrTourProps = {
  steps: Step[];
  run: boolean;
  onCallback: (data: { status?: string; type?: string; index?: number }) => void;
};

export function HrTour({ steps, run, onCallback }: HrTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({
      status: data.status,
      type: data.type,
      index: data.index,
    });
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

